const routes = [
  {
    path: '/pages/community/community',
    name: 'community',
    meta: {
      title: "社区",
      keepAlive: true,
    },
    component: () => import('../pages/community/community.vue')
  },
  {
    path: '/pages/community/pages/topicDetail',
    name: 'topicDetail',
    meta: {
      title: "帖子详情",
    },
    component: () => import('../pages/community/pages/topicDetail.vue')
  },
  {
    path: '/pages/community/pages/stickyGame',
    name: 'stickyGame',
    meta: {
      title: "置顶专区",
    },
    component: () => import('../pages/community/pages/stickyGame.vue')
  },
  {
    path: '/pages/community/pages/searchTopic',
    name: 'searchTopic',
    meta: {
      title: "搜索帖子",
      keepAlive: true,
    },
    component: () => import('../pages/community/pages/searchTopic.vue')
  },
  {
    path: '/pages/community/pages/answer',
    name: 'answer',
    meta: {
      title: "答题活动",
      keepAlive: true,
    },
    component: () => import('../pages/community/pages/answer.vue')
  },
  {
    path: '/pages/community/pages/publish',
    name: 'publish',
    meta: {
      title: "发帖",
      keepAlive: true
    },
    component: () => import('../pages/community/pages/publish.vue')
  },
  {
    path: '/pages/community/pages/draft',
    name: 'draft',
    meta: {
      title: "草稿"
    },
    component: () => import('../pages/community/pages/draft.vue')
  },
  {
    path: '/pages/daySignin/timeSignin/index',
    name: 'timeSignin',
    meta: {
      title: "限时签到"
    },
    component: () => import('../pages/community/timeSignin/index.vue')
  },
  {
    path: '/pages/daySignin/timeSignin/record',
    name: 'timeSigninRecord',
    meta: {
      title: "限时签到"
    },
    component: () => import('../pages/community/timeSignin/record.vue')
  },
  {
    path: '/pages/community/finishActive/finishActive',
    name: 'finishActive',
    meta: {
      title: "已结束活动"
    },
    component: () => import('../pages/community/finishActive/finishActive.vue')
  },
  {
    path: '/pages/community/finishActive/allActive',
    name: 'allActive',
    meta: {
      title: "全部活动"
    },
    component: () => import('../pages/community/finishActive/allActive.vue')
  },
  {
    path: '/pages/community/lotteryActivity/index',
    name: 'lotteryActivity',
    meta: {
      title: "抽奖活动"
    },
    component: () => import('../pages/community/lotteryActivity/index.vue')
  },
  
]

export default routes